import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./redux/store";
import { Provider } from "react-redux";
import ScrollToTop from "./additionalFunctions/ScrollToTop";
import { initGA } from "./additionalFunctions/GoogleAnalyticsFunctions";
const TRACKING_ID = "G-3KB37JWVNZ";
(function initAnalytics() {
  initGA(TRACKING_ID);
})();
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
